var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgeStar1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 173.226 177.246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Star 11",
    d: "M82.5574 1.03561C85.085 -0.345203 88.1414 -0.345204 90.669 1.03561L102.738 7.62905C104.111 8.37898 105.665 8.73363 107.227 8.65357L120.962 7.94974C123.838 7.80234 126.592 9.12848 128.27 11.4692L136.283 22.6464C137.195 23.9176 138.441 24.9113 139.883 25.517L152.563 30.8422C155.218 31.9574 157.124 34.347 157.62 37.1841L159.991 50.7311C160.26 52.272 160.952 53.7079 161.988 54.8793L171.102 65.1788C173.011 67.3358 173.691 70.3156 172.907 73.087L169.165 86.3208C168.739 87.8261 168.739 89.4198 169.165 90.925L172.907 104.159C173.691 106.93 173.011 109.91 171.102 112.067L161.988 122.367C160.952 123.538 160.26 124.974 159.991 126.515L157.62 140.062C157.124 142.899 155.218 145.288 152.563 146.404L139.883 151.729C138.441 152.335 137.195 153.328 136.283 154.6L128.27 165.777C126.592 168.117 123.838 169.444 120.962 169.296L107.227 168.592C105.665 168.512 104.111 168.867 102.738 169.617L90.669 176.21C88.1414 177.591 85.085 177.591 82.5574 176.21L70.4882 169.617C69.1154 168.867 67.5616 168.512 65.9994 168.592L52.2646 169.296C49.3883 169.444 46.6345 168.117 44.9564 165.777L36.9431 154.6C36.0317 153.328 34.7857 152.335 33.3434 151.729L20.6634 146.404C18.0079 145.288 16.1023 142.899 15.6059 140.062L13.2358 126.515C12.9663 124.974 12.2748 123.538 11.2382 122.367L2.12438 112.067C0.21575 109.91 -0.464373 106.93 0.319383 104.159L4.06185 90.925C4.48752 89.4198 4.48752 87.8261 4.06185 86.3208L0.319384 73.087C-0.464372 70.3156 0.215748 67.3358 2.12438 65.1788L11.2382 54.8793C12.2748 53.7079 12.9663 52.272 13.2358 50.7311L15.6059 37.1841C16.1023 34.347 18.0079 31.9574 20.6634 30.8422L33.3434 25.517C34.7857 24.9113 36.0317 23.9176 36.9431 22.6464L44.9564 11.4692C46.6345 9.12848 49.3883 7.80234 52.2646 7.94974L65.9994 8.65357C67.5616 8.73363 69.1154 8.37898 70.4882 7.62905L82.5574 1.03561Z",
    fill: "url(#paint0_linear_0_6)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_6",
    x1: 86.6132,
    y1: -1.18007,
    x2: 86.6132,
    y2: 178.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0596A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.197115,
    stopColor: "#3971F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.423077,
    stopColor: "#9A45F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615385,
    stopColor: "#FC7D06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807692,
    stopColor: "#F7E144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4626"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeStar1);
export default __webpack_public_path__ + "static/media/badge-star-1.c6f56312f46eb738f14c4fc2502a4dc9.svg";
export { ForwardRef as ReactComponent };